<template>
  <div class="empty tr-empty">
    <div class="empty-icon"><fa-icon :icon="['fal', 'hand-holding-usd']" size="3x"/></div>
    <p class="empty-title h5">{{ title }}</p>
    <p class="empty-subtitle">{{ reason }}</p>
    <p class="empty-subtitle tr-empty-scope" v-if="scope.length > 0">
      Mostrando {{ scope.join(' · ') }}
    </p>
    <div class="empty-action tr-empty-action">
      <router-link class="btn btn-primary btn-icon btn-icon-left"
                   to="/financial/billing-batches">
        <fa-icon :icon="['fal', 'layer-group']"/>Ir para Lotes
      </router-link>
    </div>
    <div class="tr-empty-links" v-if="hasStatusFilter || hasNarrowFilters">
      <button class="btn btn-link" v-if="hasStatusFilter" @click="$emit('all-statuses')">
        Incluir todos os status
      </button>
      <button class="btn btn-link" v-if="hasNarrowFilters" @click="$emit('clear-filters')">
        Limpar filtros
      </button>
    </div>
  </div>
</template>

<script>
import { origins } from '@/data/billing-transfer-origins';
import { statuses } from '@/data/billing-transfer-statuses';

export default {
  props: {
    filter: {
      type: Object,
      required: true,
    },
    scopeLabel: {
      type: String,
      default: '',
    },
    professionalName: {
      type: String,
      default: '',
    },
    insuranceName: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasStatusFilter() {
      return this.filter.statuses.length < Object.keys(statuses).length;
    },
    hasNarrowFilters() {
      return !!(this.filter.professionalId || this.filter.planId
        || this.filter.origin !== 'all');
    },
    title() {
      return this.scopeLabel
        ? `Nenhum repasse em ${this.scopeLabel}`
        : 'Nenhum repasse encontrado';
    },
    reason() {
      if (this.hasNarrowFilters) {
        return 'Nada bateu com os filtros aplicados. Amplie a busca ou troque o período.';
      }
      return 'Nenhum lote fechado, atendimento particular recebido no caixa ou laudo '
        + 'assinado gerou repasse aqui.';
    },
    scope() {
      const parts = [];
      if (this.hasStatusFilter) {
        parts.push(this.filter.statuses.map(value => statuses[value]).join(' e '));
      }
      if (this.filter.professionalId && this.professionalName) {
        parts.push(this.professionalName);
      }
      if (this.filter.planId && this.insuranceName) parts.push(this.insuranceName);
      if (this.filter.origin !== 'all') parts.push(origins[this.filter.origin]);
      return parts.filter(Boolean);
    },
  },
};
</script>
